import { ANYWHERE_PLACE_ID } from 'constants/search'
import { countOccupants } from 'lib/offer/occupancyUtils'
import GlobalSearchState from 'contexts/GlobalSearch/GlobalSearchState'
import moment from 'moment'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'

export type VerticalType = 'car_hire' | 'hotels' | 'tours' | 'cruises' | 'ultralux' | 'experiences' | 'flights';
export type SearchAnalyticsLocation = 'search-list' | 'common-search'
export type SearchAnalyticsItemType = 'recent' | 'popular' | 'standard' | undefined

export const getDestinationType = (searchItem): comluxgroup.SearchContext_1_0_0['destinationType'] => {
  if (searchItem?.searchType === 'property') {
    return 'property'
  } else if (searchItem?.searchType === 'landmark') {
    return 'landmark'
  } else if (searchItem?.value === ANYWHERE_PLACE_ID) {
    return 'anywhere'
  } else {
    return 'location'
  }
}

export const getDateType = (isAnytimeDateSelected, flexibleNights): comluxgroup.SearchContext_1_0_0['dateType'] => {
  if (isAnytimeDateSelected) {
    return 'anytime'
  } else if (flexibleNights) {
    return 'flexible'
  } else {
    return 'specific'
  }
}

export const mapGlobalSearchContextToSnowplowSearchEvent = (context: Partial<GlobalSearchState>): comluxgroup.SearchContext_1_0_0 => {
  const {
    searchItem,
    occupancies,
    isAnytimeDateSelected,
    searchVerticals,
    flexibleNights,
    checkinDate,
    checkoutDate,
  } = context
  const occupants = occupancies ? countOccupants(occupancies) : { adults: 2, children: 0 }
  const checkIn = moment(checkinDate).format(ISO_DATE_FORMAT)
  const checkOut = moment(checkoutDate).format(ISO_DATE_FORMAT)

  const destinationType = getDestinationType(searchItem)
  const dateType = getDateType(isAnytimeDateSelected, flexibleNights)

  return {
    adults: occupants.adults,
    children: occupants.children,
    rooms: occupancies?.length || 0,
    dateType,
    startDate: dateType === 'specific' ? checkIn : undefined,
    endDate: dateType === 'specific' ? checkOut : undefined,
    vertical: (searchVerticals ? [...searchVerticals][0] : undefined) as VerticalType,
    durationType: (flexibleNights === '1-30' ? 'any' : flexibleNights) || undefined,
    destinationType,
    destinations: searchItem?.format.mainText ? [searchItem.format.mainText] : [],
    destinationIds: searchItem?.value ? [searchItem?.value] : [],
  }
}

export const mapRecentSearchDataToSnowplowSearchEvent = (recentSearch, searchVerticals): comluxgroup.SearchContext_1_0_0 => {
  const occupants = countOccupants(recentSearch.rooms)
  const isAnytime = recentSearch.dates.isAnytime
  const isFlexible = !!recentSearch.dates.flexibleMonths || !!recentSearch.dates.flexibleDuration
  const dateType = getDateType(isAnytime, isFlexible)
  const destinationType = getDestinationType(recentSearch.searchItem)

  return {
    adults: occupants.adults,
    children: occupants.children,
    rooms: recentSearch.rooms?.length || 0,
    dateType,
    startDate: recentSearch.dates?.checkIn || undefined,
    endDate: recentSearch.dates?.checkOut || undefined,
    vertical: [...searchVerticals][0] as VerticalType,
    durationType: (recentSearch.dates?.flexibleDuration === '1-30' ? 'any' : recentSearch.dates?.flexibleDuration) || undefined,
    destinationType,
    destinations: [recentSearch.searchItem?.format.mainText],
    destinationIds: [recentSearch.searchItem?.value],
  }
}
